<div class="districts-container">

  <!-- Header -->
  <div class="header">
    <div class="header-content">
      <div>
        <h1>Districts</h1>
        <p>Manage districts used to group zones for reporting</p>
      </div>
      <button class="create-btn" (click)="toggleCreateForm()">
        <i class="fas" [ngClass]="showCreateForm ? 'fa-times' : 'fa-plus'"></i>
        {{ showCreateForm ? 'Cancel' : 'New District' }}
      </button>
    </div>
  </div>

  <!-- Notification -->
  <div class="notification" *ngIf="notification.show" [ngClass]="notification.type">
    <i class="fas" [ngClass]="{
      'fa-check-circle': notification.type === 'success',
      'fa-times-circle': notification.type === 'error',
      'fa-info-circle':  notification.type === 'info'
    }"></i>
    <span>{{ notification.message }}</span>
    <button class="notif-close" (click)="closeNotification()">
      <i class="fas fa-times"></i>
    </button>
  </div>

  <!-- Inline Create Form -->
  <div class="create-form-panel" *ngIf="showCreateForm">
    <div class="panel-header">
      <h2><i class="fas fa-map"></i> New District</h2>
    </div>

    <form (ngSubmit)="onSubmit()" #districtForm="ngForm" class="panel-body">
      <!-- General error -->
      <div class="error-banner" *ngIf="hasError('general')">
        <i class="fas fa-exclamation-circle"></i>
        {{ getError('general') }}
      </div>

      <div class="form-group">
        <label for="districtName" class="form-label">
          District Name <span class="required">*</span>
        </label>
        <input
          type="text"
          id="districtName"
          name="districtName"
          [(ngModel)]="districtData.name"
          [class.error]="hasError('name')"
          class="form-input"
          placeholder="e.g. North, Central, Coastal"
          required
          maxlength="100"
          [disabled]="isSubmitting">
        <div class="field-error" *ngIf="hasError('name')">
          <i class="fas fa-exclamation-triangle"></i> {{ getError('name') }}
        </div>
      </div>

      <div class="form-actions">
        <button type="button" class="btn btn-secondary" (click)="onCancelCreate()" [disabled]="isSubmitting">
          Cancel
        </button>
        <button type="submit" class="btn btn-primary" [disabled]="isSubmitting || !districtForm.valid">
          <span *ngIf="!isSubmitting"><i class="fas fa-plus-circle"></i> Create District</span>
          <span *ngIf="isSubmitting"><i class="fas fa-spinner fa-spin"></i> Creating...</span>
        </button>
      </div>
    </form>
  </div>

  <!-- Search + List -->
  <div class="list-section">
    <div class="search-bar">
      <i class="fas fa-search search-icon"></i>
      <input
        type="text"
        [(ngModel)]="searchQuery"
        (ngModelChange)="onSearchChange()"
        placeholder="Search districts..."
        class="search-input">
    </div>

    <!-- Loading -->
    <div class="loading-state" *ngIf="isLoading">
      <i class="fas fa-spinner fa-spin"></i>
      <span>Loading districts...</span>
    </div>

    <!-- Empty state -->
    <div class="empty-state" *ngIf="!isLoading && filteredDistricts.length === 0">
      <i class="fas fa-map"></i>
      <p *ngIf="searchQuery">No districts match "<strong>{{ searchQuery }}</strong>"</p>
      <p *ngIf="!searchQuery">No districts yet. Click <strong>New District</strong> to add one.</p>
    </div>

    <!-- Districts List -->
    <div class="districts-list" *ngIf="!isLoading && filteredDistricts.length > 0">
      <div class="district-row" *ngFor="let district of filteredDistricts">
        <div class="district-icon">
          <i class="fas fa-map-marker-alt"></i>
        </div>
        <div class="district-info">
          <span class="district-name">{{ district.name }}</span>
          <span class="district-id">ID: {{ district.id }}</span>
        </div>
        <span class="district-status" *ngIf="district.disabled">Disabled</span>
      </div>
    </div>

    <!-- Result count -->
    <div class="result-count" *ngIf="!isLoading && filteredDistricts.length > 0">
      Showing {{ filteredDistricts.length }} of {{ districts.length }} districts
    </div>
  </div>

</div>
